import { defineStore } from 'pinia';

export const UserStore = defineStore('users', {
  state: () => {
    return {
      token: '',
      userInfo: {},
    };
  },
  getters: {
    getToken: (state) => {
      return state.token;
    },
    getUserInfo: (state) => {
      return state.userInfo;
    },
  },
  actions: {
    setToken(token: string) {
      console.log(token, 'token:::::::::::::');
      this.token = token;
    },
    setUserInfo() {
      // 获取用户信息
    },
    resetToken() {
      this.token = '';
      this.userInfo = {};
    },
  },
  persistence: {
    enable: true,
    option: [{ key: 'user_token', storage: localStorage, states: ['token'] }],
  },
});
